import React from "react";
import { Button, Modal, Form } from "react-bootstrap";
import FormikForm from "components/shared/FormikForm";
import Validation from "views/avatar/avatarCategory/Validation";
import InputFields from "views/avatar/avatarCategory/inputFields";

export default function AddAvatarCategoryModal({
  show,
  handleClose,
  handleConfirm,
  title,
  content,
  loading,
  initialValues,
}) {
  return (
    <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
      >
        <Modal.Header className="py-3 text-dark" closeButton>
          <Modal.Title className="fw-bold text-dark">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormikForm
            initialValues={initialValues}
            validationSchema={Validation}
            onSubmit={handleConfirm}
            loading={loading}
            inputFields={InputFields}
            buttonText={"Submit"}
          />
        </Modal.Body>
      </Modal>
  );
}